import { Box, Col, Row } from "@intech/web-ui";
import styled from "styled-components";

export const BoxCalendario = styled(Box)`
  color: #7c7e80;
`;

export const Mes = styled(Col)`
  display: flex;
  flex: 1;
`;

export const Dia = styled(Col)`
  display: flex;
  flex: 0;
  align-items: flex-end;
  font-weight: bold;
`;

export const StripedRow = styled(Row)`
  &:nth-of-type(2n+1) {
    background-color: rgba(0,0,0,0.09);
  }
`;